const hubspotForm = document.querySelector(".hubspot-form");
const quoteFormContainer = document.querySelector(".hubspot-form-quote");
const quoteTemplate = document.getElementById("quote-item-template");
const quoteContainer = document.querySelector(".quote-form-container");
const quoteGrid = document.querySelector(".quote-form-grid");

const handleCheckboxes = () => {
    const fieldContainer = document.querySelector(".hs-form-field .inputs-list");
    const iconData = JSON.parse(document.getElementById("quote-form-icons").textContent);

    if (!fieldContainer) {
        return;
    } else if (window.hubspotFormObserver) {
        window.hubspotFormObserver.disconnect();
    }

    fieldContainer.closest("fieldset").classList.add("hs-hidden");

    const isRequired = fieldContainer.closest("ul").hasAttribute("required");

    const checkboxes = fieldContainer.querySelectorAll('input[type="checkbox"]');

    if (!checkboxes.length) {
        return;
    }

    checkboxes.forEach((checkbox) => {
        const label = checkbox.parentNode.querySelector("span").textContent;
        const id = checkbox.id;
        const node = quoteTemplate.content.cloneNode(true);

        const foundIcon = iconData.icons.find((x) => x.label === label);
        let svgIcon;

        if (foundIcon) {
            svgIcon = foundIcon.icon;
        } else {
            svgIcon = null;
        }

        node.querySelector(".product-label").textContent = label;
        node.querySelector(".svg-holder").innerHTML = svgIcon;
        node.querySelector("input[type=checkbox]").id = `product-${id}`;
        node.querySelector("label").setAttribute("for", `product-${id}`);

        node.querySelector("input[type=checkbox]").addEventListener("change", (e) => {
            checkbox.click();

            const productWrapper = e.target.closest(".product-wrapper");
            productWrapper.classList.toggle("is-active");
        });

        quoteGrid.appendChild(node);
    });

    quoteContainer.classList.remove("hidden");

    if (isRequired && quoteContainer) {
        const validateCheckboxes = () => {
            const customCheckboxes = quoteContainer.querySelectorAll('.product-wrapper input[type="checkbox"]:checked');
            const errorMessage = quoteContainer.querySelector(".error-message") || document.createElement("div");

            if (!customCheckboxes.length) {
                errorMessage.classList.add("error-message");
                errorMessage.textContent = "Please select at least one option";

                if (!quoteContainer.querySelector(".error-message")) {
                    quoteContainer.appendChild(errorMessage);

                    const scrollOptions = {
                        top: errorMessage,
                        behavior: "smooth",
                    };
                    window.scrollTo(scrollOptions);
                }
                return false;
            } else {
                if (quoteContainer.querySelector(".error-message")) {
                    quoteContainer.querySelector(".error-message").remove();
                }
                return true;
            }
        };

        const form = hubspotForm.querySelector("form");
        if (form) {
            form.addEventListener("submit", (e) => {
                if (!validateCheckboxes()) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            });
        }

        const customCheckboxes = quoteContainer.querySelectorAll('.product-wrapper input[type="checkbox"]');
        customCheckboxes.forEach(checkbox => {
            checkbox.addEventListener("change", validateCheckboxes);
        });
    }
};

const handleFileUpload = () => {
    const fileUpload = document.querySelector(".hbspt-form .input input[type=file]");

    if (!fileUpload) {
        return;
    } else if (window.hubspotFormObserver) {
        window.hubspotFormObserver.disconnect();
    }

    const preview = document.createElement("div");
    preview.classList.add("file-upload-preview");
    fileUpload.closest(".input").appendChild(preview);

    fileUpload.addEventListener("change", (e) => {
        preview.textContent = "";

        const files = Array.from(e.target.files);
        const dataTransfer = new DataTransfer();

        if (!files.length) {
            return;
        }

        files.forEach((file) => {
            const fileContainer = document.createElement("div");
            fileContainer.classList.add("file-container");
            preview.appendChild(fileContainer);

            const fileName = document.createElement("span");
            fileName.classList.add("filename");
            fileName.textContent = file.name;
            fileContainer.appendChild(fileName);

            const fileRemoveButton = document.createElement("button");
            fileRemoveButton.textContent = "Remove File";
            fileRemoveButton.classList.add("file-remove-button");
            fileContainer.appendChild(fileRemoveButton);

            dataTransfer.items.add(file);

            fileRemoveButton.addEventListener("click", () => {
                fileContainer.remove();

                dataTransfer.items.clear();
                files.forEach((f) => {
                    if (f !== file) {
                        dataTransfer.items.add(f);
                    }
                });

                fileUpload.files = dataTransfer.files;
            });
        });

        fileUpload.files = dataTransfer.files;
    });
}

if (hubspotForm) {
    const observer = new MutationObserver((mutationList, observer) => {
        for (const mutation of mutationList) {
            if (mutation.type === "childList") {
                if (hubspotForm.querySelector(".hs-form-field")) {
                    const fileUploadField = hubspotForm.querySelector(".hs-form-field input[type=file]");
                    if (fileUploadField) {
                        handleFileUpload();
                    }

                    const checkboxField = hubspotForm.querySelector(".hs-form-field .inputs-list");
                    if (checkboxField) {
                        handleCheckboxes();
                    }

                    observer.disconnect();
                }
            }
        }
    });


    window.hubspotFormObserver = observer;
    observer.observe(hubspotForm, { childList: true, subtree: true });
}
